<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter2">
<h1 class="left"><a id="page_36"></a><a href="#/005toc#ch2"><span class="yellow">CHICKEN SPREAD</span></a></h1>
<p class="noindent">Use a food processor to grind up leftover cooked chicken and make it into a smooth spread for crostini or small open-faced cocktail sandwiches.</p>
<p class="hang-space1">2 cups cut-up cooked chicken pieces</p>
<p class="hang">2 or 3 mushrooms, cut up</p>
<p class="hang">1 shallot, chopped, or 2 green onions including some tender green tops, cut up</p>
<p class="hang">1 sprig fresh parsley, cut up</p>
<p class="hang">3 to 4 tablespoons mayonnaise</p>
<p class="hang">1 teaspoon Dijon mustard</p>
<p class="hang">Crostini (toasted baguette) slices for serving (recipe follows)</p>
<p class="noindent-space1">Place all the ingredients except the baguette slices in a food processor and process until smooth. Scrape down the sides of the bowl as needed. Spread on crostini.</p>
<p class="noindent-space1">Makes 12 to 14 crostini</p>
<h4><strong>CROSTINI</strong></h4>
<p class="noindent">Crostini are thin, toasted baguette slices to serve with soups or as a base for hors d’oeuvre toppings.</p>
<p class="hang-space1"><sup class="frac">1</sup>/<sub class="frac">4</sub> cup olive oil</p>
<p class="hang">2 large garlic cloves, quartered</p>
<p class="hang">1 baguette, cut into <sup class="frac">1</sup>/<sub class="frac">4</sub>- to <sup class="frac">1</sup>/<sub class="frac">3</sub>3-inch slices</p>
<p class="noindent-space1">In a small jar, combine the oil and garlic. Let stand to allow the oil to absorb flavor, about 30 minutes.</p>
<p class="noindent-space1"><span class="yellow"><strong>TO BROIL:</strong></span> Preheat the broiler. Arrange the bread slices on a baking sheet and brush them with the garlic oil. Broil on 1 side until toasted, about 1 minute. Turn the slices over and brush with garlic oil. Broil about 40 seconds longer.</p>
<p class="noindent-space1"><span class="yellow"><strong>TO BAKE:</strong></span> Preheat the oven to 350°F. Arrange the bread slices on a baking sheet and brush both sides with the garlic oil. Bake until lightly browned, about 15 minutes.</p>
<p class="noindent-space1">Makes about 30 slices</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010-chapter2.vue?6b277fff